var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-child-progress"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("学习进度")]),_c('p',[_vm._v("孩子ID: "+_vm._s(_vm.$route.params.childId))]),_c('p',[_vm._v("孩子学习进度详情页面，开发中...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }